export function isRefreshRequest(url = '') {
  try {
    const pathname = url.startsWith('http')
      ? new URL(url).pathname
      : url.split('?')[0].split('#')[0];
    return pathname === '/token/refresh';
  } catch {
    return false;
  }
}

export function createRefreshCoordinator() {
  let refreshPromise = null;

  return {
    async runExclusiveRefresh(refreshFn) {
      if (!refreshPromise) {
        refreshPromise = Promise.resolve()
          .then(refreshFn)
          .finally(() => {
            refreshPromise = null;
          });
      }
      return refreshPromise;
    },
    reset() {
      refreshPromise = null;
    },
  };
}

const defaultCoordinator = createRefreshCoordinator();

export function runExclusiveRefresh(refreshFn) {
  return defaultCoordinator.runExclusiveRefresh(refreshFn);
}

export function resetRefreshCoordinator() {
  defaultCoordinator.reset();
}
